import React from 'react';

export const InternalDomainContext = React.createContext<boolean>(false);
InternalDomainContext.displayName = 'InternalDomainContext';

export const useIsInternalDomain = () => {
  return React.useContext(InternalDomainContext);
};
